import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper';
import formConfig from './formConfig.json';

const LogoSlider = ({ onLogoSelect, clientId }) => {
  const defaultLogos = [
    { id: 29, url: 'https://storage.googleapis.com/retooluploadstuff/coca-cola.png' },
    { id: 2035, url: 'https://storage.googleapis.com/retooluploadstuff/etoro.png' },
    { id: 2036, url: 'https://storage.googleapis.com/retooluploadstuff/google-square.png' },
    { id: 1929, url: 'https://storage.googleapis.com/retooluploadstuff/ups.png' },
    { id: 90, url: 'https://storage.googleapis.com/retooluploadstuff/adidas.png' },
  ];

  const logos = formConfig[clientId]?.sliderLogos || formConfig.default.sliderLogos || defaultLogos;
  const shouldAutoGenerate = formConfig[clientId]?.autoGenerateMockups || formConfig.default.autoGenerateMockups;

  const handleLogoClick = (logo) => {
    onLogoSelect(logo, shouldAutoGenerate);
  };

  return (
    <div className="mt-6 w-full">
      <h6 className="text-base font-semibold text-gray-800 mb-3">Select a sample logo</h6>
      <div className="border border-gray-200 rounded-lg p-1 bg-gray-50">
        <Swiper
          slidesPerView={3}
          spaceBetween={16}
          navigation={true}
          modules={[Navigation]}
          className="logo-slider"
        >
          {logos.map((logo) => (
            <SwiperSlide key={logo.id}>
              <div 
                className="h-24 w-24 flex items-center justify-center bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow duration-200 cursor-pointer" 
                onClick={() => handleLogoClick(logo)}
              >
                <img
                  src={logo.url}
                  alt={`Logo ${logo.id}`}
                  className="max-h-20 max-w-20 object-contain"
                />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default LogoSlider;